// How each ending result is shown wherever it appears (the Ending results
// card, its legend and links), so order, names, colours and filters cannot
// drift apart. Won and Drawn take the charts' win and draw colours; the two
// surprises their own tokens (colors.css): Comeback a gold, Blown win the
// ending cases' deep red; a plain loss the cases' red-tinted grey. `cell`
// names one start × outcome cell for a tooltip.
import type { EndingResult, EndingStart, GameOutcome } from '@chess/api-model';

export interface EndingResultView {
  result: EndingResult;
  label: string;
  /** A colour token, e.g. `var(--viz-ending-comeback)`. */
  colour: string;
  /** One sentence on the result, from the reader's side. */
  description: string;
}

export const ENDING_RESULT_VIEWS: readonly EndingResultView[] = [
  { result: 'won', label: 'Won', colour: 'var(--viz-ending-won)', description: 'You won from a winning or level start of the ending.' },
  { result: 'comeback', label: 'Comeback', colour: 'var(--viz-ending-comeback)', description: 'The ending started lost and you won or drew.' },
  { result: 'drawn', label: 'Drawn', colour: 'var(--viz-ending-drawn)', description: 'The ending started level and it was drawn.' },
  { result: 'blown', label: 'Blown win', colour: 'var(--viz-ending-blown)', description: 'The ending started winning and you drew or lost.' },
  { result: 'lost', label: 'Lost', colour: 'var(--viz-ending-lost)', description: 'You lost from a level or lost start of the ending.' },
];

/** The view of one result. */
export function endingResultView(r: EndingResult): EndingResultView {
  return ENDING_RESULT_VIEWS.find((v) => v.result === r)!;
}

const STARTED: Record<EndingStart, string> = { winning: 'started winning', level: 'started level', lost: 'started lost' };
const ENDED: Record<GameOutcome, string> = { win: 'won', draw: 'drawn', loss: 'lost' };

/** One start × outcome cell in words, e.g. "started winning, drawn". */
export function endingCellText(start: EndingStart, outcome: GameOutcome): string {
  return `${STARTED[start]}, ${ENDED[outcome]}`;
}
